import { styled, Button as UiButton, Link as UiLink } from "@mui/material"

export const Link = styled(UiLink, { shouldForwardProp: prop => prop !== "linkColor" })(({ theme, linkColor }) => {
    const color = linkColor ? theme.palette[linkColor].main : theme.palette["cta-bg/cta-bg-primary"].main
    return {
        color: color,
        textDecorationColor: color,
        width: "fit-content",
    }
})

export const Button = styled(UiButton)(() => ({
    boxShadow: "0px 0px 0px 0px",

    "&:hover": {
        boxShadow: "0px 0px 0px 0px",
    },
}))
